var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import './Toast.css';
var Toast = function (props) {
    var toastQueue = props.toastQueue;
    var toastClass = function (type) {
        switch (type) {
            case 'success': return 'sdds-toast-success';
            case 'warning': return 'sdds-toast-warning';
            case 'error': return 'sdds-toast-error';
            default: return 'sdds-toast-info';
        }
    };
    return (React.createElement(React.Fragment, null, toastQueue.length > 0 && (React.createElement("div", { id: "toast-component-container" }, toastQueue.map(function (toast, index) { return (React.createElement("div", { id: "toast-component-item-".concat(index), key: "toast-component-item-".concat(toast.timeAdded), className: "sdds-toast ".concat(toastClass(toast.type)) },
        React.createElement("div", { className: "sdds-toast-icon" },
            React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" })),
        React.createElement("div", { className: "sdds-toast-content" },
            React.createElement("div", { className: "sdds-toast-header" }, toast.title && React.createElement("span", { className: "sdds-toast-headline" }, toast.title)),
            React.createElement("div", { className: "sdds-toast-body" },
                React.createElement("span", { className: "sdds-toast-subheadline" }, toast.text))))); })))));
};
var useToast = function () {
    var _a = useState([]), toastQueue = _a[0], setToastQueue = _a[1];
    var addToast = function (toast) {
        setToastQueue(__spreadArray(__spreadArray([], toastQueue, true), [__assign(__assign({}, toast), { timeAdded: new Date() })], false));
    };
    useEffect(function () {
        var interval;
        if (toastQueue.length > 0) {
            interval = setInterval(function () {
                var now = new Date().getTime();
                setToastQueue(toastQueue.filter(function (toast) { var _a; return (now - ((_a = toast.timeAdded) === null || _a === void 0 ? void 0 : _a.getTime())) < 4000; }));
            }, 1000);
        }
        return function () {
            clearInterval(interval);
        };
    }, [toastQueue]);
    return {
        toastQueue: toastQueue,
        addToast: addToast,
    };
};
export default Toast;
export { useToast, };
